import type { InferRequestType, InferResponseType } from 'hono/client';
import { type ApiClient, useFetch, useMutation } from '../api';

type GetDeviceTransfers = ApiClient['v1']['device-transfer']['$get'];
export type DeviceTransferListQuery = InferRequestType<GetDeviceTransfers>['query'];
export type DeviceTransferListResponse = InferResponseType<GetDeviceTransfers, 200>;
export type DeviceTransfer = DeviceTransferListResponse['deviceTransfers'][number];

type CreateDeviceTransfer = ApiClient['v1']['device-transfer']['$post'];
export type CreateDeviceTransferRequest = InferRequestType<CreateDeviceTransfer>['json'];
export type DeviceTransferResponse = InferResponseType<CreateDeviceTransfer, 202>;

type UpdateDeviceTransfer = ApiClient['v1']['device-transfer'][':deviceTransferId']['$put'];
export type DeviceTransferAction = InferRequestType<UpdateDeviceTransfer>['json']['status'];

export function useDeviceTransfers(params: DeviceTransferListQuery = {}) {
  return useFetch<DeviceTransferListResponse>(
    `device-transfers?${JSON.stringify(params)}`,
    (client) => client.v1['device-transfer'].$get({ query: params }),
    undefined,
    { keepPreviousData: true }
  );
}

export function useCreateDeviceTransfer() {
  return useMutation<DeviceTransferResponse, CreateDeviceTransferRequest>(
    'device-transfers',
    (client, data) => client.v1['device-transfer'].$post({ json: data })
  );
}

export function useUpdateDeviceTransfer() {
  return useMutation<
    DeviceTransferResponse,
    { deviceTransferId: number; status: DeviceTransferAction }
  >('device-transfers', (client, { deviceTransferId, status }) =>
    client.v1['device-transfer'][':deviceTransferId'].$put({
      param: { deviceTransferId: deviceTransferId.toString() },
      json: { status },
    })
  );
}
